import { jsx, jsxs } from "react/jsx-runtime";
import { Form, Flex, Combobox, Input, Button } from "@zillow/constellation";
import "react";
import { useTheme } from "styled-components";
const AgentSearch = ({
  placeholder,
  search,
  disabled
}) => {
  const theme = useTheme();
  let zip = "";
  const handleSelectChange = (item) => {
    if (search === "installations" && item) {
      zip = INSTALLATIONS.find((inst) => inst[0] === item)[1];
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.target;
    const url = "https://www.zillow.com/professionals/relocation--real-estate-agent-reviews/" + zip;
    form.action = url;
    form.submit();
  };
  const INSTALLATIONS = [["Fort Novosel", "36362"], ["Portsmouth Naval Shipyard", "03904"], ["Camp Pendleton", "92055"]];
  const INSTALLAIONS_NAMES = INSTALLATIONS.map((inst) => inst[0]);
  return /* @__PURE__ */ jsx(Form, { onSubmit: handleSubmit, target: "_blank", children: /* @__PURE__ */ jsxs(Flex, { display: "flex", flexDirection: "column", children: [
    search === "installations" ? /* @__PURE__ */ jsx(Combobox, { options: INSTALLAIONS_NAMES, placeholder, "aria-label": "installations", name: "installations", onChange: handleSelectChange, disabled: disabled ? "disabled" : void 0 }) : /* @__PURE__ */ jsx(Input, { type: "text", "aria-label": "zipcode", name: "zipcode", placeholder, disabled: disabled ? "disabled" : void 0, onChange: (event) => zip = event.target.value }),
    /* @__PURE__ */ jsx(Button, { buttonType: "primary", disabled: disabled ? "disabled" : void 0, style: {
      width: "100%",
      marginTop: theme.constellation.spacing.md
    }, children: "Find an agent" })
  ] }) });
};
export {
  AgentSearch as default
};
